import { render, staticRenderFns } from "./ArticleManage.vue?vue&type=template&id=ed06736a&scoped=true&"
import script from "./ArticleManage.vue?vue&type=script&lang=js&"
export * from "./ArticleManage.vue?vue&type=script&lang=js&"
import style0 from "./ArticleManage.vue?vue&type=style&index=0&id=ed06736a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed06736a",
  null
  
)

export default component.exports